export const environment = {
    production: true,
    hostUrl: 'https://os.explainapi.co.uk',
    apiUrl: 'https://os.explainapi.co.uk/api/v1',
    whitelist: ['os.explainapi.co.uk'],
    blacklist: ['/login'],
    primaryColor: '#1c7985',
    accentColor: '#c93457',
    masterGaId: 'G-DSD0FGDB93',
    environmentName: 'production',
    SocketIoUrl: 'https://sockets.explainapi.co.uk',
    favicon16: '/assets/favicon/os_logo_16px.png',
    favicon32: '/assets/favicon/os_logo_32px.png',
    appleTouchIcon: '/assets/favicon/os_logo_180px.png',
};

